import React, {Fragment, useContext, useEffect} from 'react'

import {BasketContext} from '../../context'

import BreadCrumbs from '../../bread-crumbs'

const OrderDone = ({history, location}) => {
  const {setBasket, setCartId} = useContext(BasketContext);
  const {order} = location.state;

  useEffect(() => {
    const {cart} = order;

    if (cart) {
      setCartId('');
      setBasket([]);
    }
  }, [order]);

  const handleClick = event => {
    event.preventDefault();

    history.push('/catalogue')
  };

  return (
    <Fragment>
      <div className="wrapper order-wrapper">
        <BreadCrumbs path={[
          {title: 'Корзина', link: '/order'},
          {title: 'Оформление заказа'},
          {title: 'Заказ принят'}
          ]}/>
        <section className="order-done">
          <h2 className="order-done__title order-process__title">Заказ принят, спасибо!</h2>
          <div className="order-done__information order-info">
            <div className="order-info__item order-info__item_summ">
              <h3>Сумма заказа:</h3>
              <p>{order && order.orderTotal.toLocaleString('ru-RU')}&nbsp;<i className="fa fa-rub" aria-hidden="true"/></p>
            </div>
            <div className="order-info__item order-info__item_pay-form">
              <h3>Способ оплаты:</h3>
              <p>{order && order.paymentTitle}</p>
            </div>
            <div className="order-info__item order-info__item_customer-name">
              <h3>Имя клиента:</h3>
              <p>{order && order.name}</p>
            </div>
            <div className="order-info__item order-info__item_adress">
              <h3>Адрес доставки:</h3>
              <p>{order && order.address}</p>
            </div>
            <div className="order-info__item order-info__item_phone">
              <h3>Телефон:</h3>
              <p>{order && order.phone}</p>
            </div>
          </div>
          <p className="order-done__notice">Данные о заказе отправлены на
            адрес <span>{order && order.email}.  </span></p>
          <button className="order-done__continue" onClick={handleClick}>
            продолжить покупки
          </button>
        </section>
      </div>
    </Fragment>
  )
};

export default OrderDone
